<!-- eslint-disable max-len -->
<template>
  <div >
    <Card title="Album Management">
      <template v-slot:button>
        <Button v-if="isArtist" variant="primary" label="Add Album" @clicked="toggleModal" />
      </template>
      <template v-slot:body>
        <div class="pb-3 flex justify-between items-center w-full">
          <div class="flex flex-col items-center w-full">
            <el-row class="w-full pb-3" :gutter="10">
              <el-col :span="8">
                <el-input placeholder="search album name" v-model="filterAlbum" @change="searchAlbum" ></el-input>
              </el-col>
              <el-col v-if="!isArtist" :span="8" >
                <el-input placeholder="search artist name" v-model="filterArtist" @change="searchAlbum" ></el-input>
              </el-col>
              <el-col v-if="!isArtist" :span="4" class="flex flex-row" >
                <Button @clicked="searchAlbum" label="Apply"/>
                <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="resetAlbum" /></button>
              </el-col>

            </el-row>
            <el-row class="w-full pb-3" :gutter="10">
              <el-col v-if="!isArtist" :span="24" class="flex flex-row gap-3" >
                <div @click="filterStatus = 0" class="md:w-50 ">
                  <div v-bind:class="filterStatus == 0? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
                    <p class="m-auto text-xs font-medium">
                      Waiting For Review ({{countWaitingForReviewAlbum}})
                    </p>
                  </div>
                </div>
                <div @click="filterStatus = 1" class="md:w-40 ">
                  <div v-bind:class="filterStatus == 1? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
                    <p class="m-auto text-xs font-medium">
                      Under Review ({{countUnderReviewAlbum}})
                    </p>
                  </div>
                </div>
                <div @click="filterStatus = 2" class="md:w-40 ">
                  <div v-bind:class="filterStatus == 2? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
                    <p class="m-auto text-xs font-medium">
                      Approved ({{countApprovedAlbum}})
                    </p>
                  </div>
                </div>
                <div @click="filterStatus = 3" class="md:w-40 ">
                  <div v-bind:class="filterStatus == 3? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
                    <p class="m-auto text-xs font-medium ">
                      Rejected ({{countRejectedAlbum}})
                    </p>
                  </div>
                </div>
                <div @click="filterStatus = 4" class="md:w-40 ">
                  <div v-bind:class="filterStatus == 4? 'bg-indigo-500 text-gray-100' : ''" class="flex items-center p-4 bg-indigo-200 rounded-lg shadow-xs cursor-pointer hover:bg-indigo-500 hover:text-gray-100">
                    <p class="m-auto text-xs font-medium ">
                      Published ({{countPublishedAlbum}})
                    </p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <data-tables-server ref="tableAlbum" :data="dataAlbum" :total="totalAlbum" :pagination-props="{ background: true,pageSizes: [6] }" @query-change="onChangeAlbumTable" >

          <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
          </el-table-column>

          <el-table-column v-if="isArtist || isFinance || isRecruitment" label="Publish" class="text-center" >
            <template slot-scope="scope">
              {{ scope.row.published ? 'Published' : 'Not Published' }}
            </template>
          </el-table-column>

          <el-table-column v-if="(isAdmin || isSuperAdmin || isOps || isRecruitment) && filterStatus!==0 && filterStatus!==1 && filterStatus!==3" label="Publish" class="text-center" width="100px" >
            <template slot-scope="scope">
              <label
                :for="'toogle'+scope.row.id"
                class="flex items-center"
                :class="isEligiblePublished(scope.row)? 'cursor-pointer' : 'cursor-not-allowed'"
                style="height: 50px;"
              >
                <!-- toggle -->
                <div class="relative m-auto">
                  <!-- input -->
                  <input
                    :id="'toogle'+scope.row.id"
                    type="checkbox" v-model="scope.row.published"
                    @change="submitPublishedAlbum(scope.row)"
                    :disabled="!isEligiblePublished(scope.row)"
                    class="hidden"
                  />
                  <!-- line -->
                  <div
                    class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                  ></div>
                  <!-- dot -->
                  <div
                    class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                  ></div>
                </div>
                <!-- label -->
              </label>
            </template>
          </el-table-column>

          <el-table-column v-if="!isFinance && !isRecruitment" label="Actions" align="right" min-width="100px">
            <template slot-scope="scope">
              <div class="static inline-block text-left container-action">
                <VueCustomTooltip label="See Detail" :position="'is-left'">
                  <button @click="detail($event,scope.row)" class="p-2 mr-2 rounded bg-blue-500 hover:bg-blue-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'eye']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="isArtist" label="Edit" :position="'is-left'">
                  <button  @click="edit($event, scope.row)" class="p-2 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="scope.row.canDelete && (isSuperAdmin || isAdmin)" label="Delete" :position="'is-left'">
                  <button  @click="deleteAlbum($event, scope.row)"  class="p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="!isArtist && isEligibleUnderReview(scope.row)" label="Set Under Review" :position="'is-left'">
                  <button  @click="submitUnderReviewAlbum($event, scope.row)" class="p-2 w-8 mr-2 rounded bg-purple-400 hover:bg-purple-500 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'file-alt']" />
                  </button>
                </VueCustomTooltip>
                <VueCustomTooltip v-if="(isAdmin || isSuperAdmin || isOps || isReviewer) && scope.row.statusCode==2" label="Add Tags" :position="'is-left'">
                  <button  @click="addTags(scope.row)" class="p-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none" >
                    <font-awesome-icon class="text-white" :icon="['fa', 'tags']" />
                  </button>
                </VueCustomTooltip>
              </div>
            </template>
          </el-table-column>
        </data-tables-server>
      </template>

    </Card>
    <ModalDialog
      :isShowingModal="isShowingModalEdit"
      :isLoading="isLoading"
      labelSubmit="Save"
      title="Edit Album Details"
      @toggleModal="toggleModalEdit()"
      @save="submitForUpdate()" >
      <template slot="body" >
        <EditAlbum ref="editAlbumContent" @on-edit-album="onSubmitEditAlbum" :toggle-reset="isShowingModalEdit"  :album-id="idAlbum" :musicverse-cut="getUser.musicverse_cut" :artist-cut="getUser.artist_cut"></EditAlbum>
      </template>
    </ModalDialog>
    <ModalDialog
      :isShowingModal="isShowingModal"
      :isLoading="isLoading"
      title="Add Album Details"
      @toggleModal="toggleModal()"
      @save="submitForReview()" >
      <template slot="body" >
        <AddAlbum ref="addAlbumContent" @on-submit-album="onSubmitAlbum" :toggle-reset="isShowingModal"  :musicverse-cut="getUser.musicverse_cut" :artist-cut="getUser.artist_cut"></AddAlbum>
      </template>
    </ModalDialog>
    <ModalDialog
      :isShowingModal="isShowingModalListSong"
      :isLoading="isLoading"
      title="Add Song to Album"
      labelSubmit="Add to Album"
      @toggleModal="isShowingModalListSong = !isShowingModalListSong"
      @save="addToAlbum"
    >
      <template slot="body" >
        <data-tables :data="dataSong" :total="totalSong" :pagination-props="{ pageSizes: [6] }" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>

          <el-table-column v-for="title in titleSong" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
          </el-table-column>

          <el-table-column label="Song" width="250px" >
            <template slot-scope="scope">
              <audio controls :src="scope.row.file" :id="'audioPlayer'+scope.row.id" class="audio-player" style="width: 240px;" controlsList="nodownload" type="audio/mp3" preload="none" >
                Audio tag not supported
              </audio>
            </template>
          </el-table-column>
        </data-tables>
      </template>
    </ModalDialog>
    <ModalDialog
      :isShowingModal="isShowingModalListSongEdit"
      :isLoading="isLoading"
      title="Add Song to Album"
      labelSubmit="Add to Album"
      @toggleModal="isShowingModalListSongEdit = !isShowingModalListSongEdit"
      @save="addToAlbumEdit"
    >
      <template slot="body" >
        <data-tables :data="dataSong" :total="totalSong" :pagination-props="{ pageSizes: [6] }" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>

          <el-table-column v-for="title in titleSong" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
          </el-table-column>

          <el-table-column label="Song" width="250px" >
            <template slot-scope="scope">
              <audio controls :src="scope.row.file" :id="'audioPlayer'+scope.row.id" class="audio-player" style="width: 240px;" controlsList="nodownload" type="audio/mp3" preload="none" >
                Audio tag not supported
              </audio>
            </template>
          </el-table-column>
        </data-tables>
      </template>
    </ModalDialog>
    <ModalDialogDetail
      :isShowingModal="isShowingModalDetail"
      :isLoading="isLoading"
      title="Album Details"
      @toggleModal="isShowingModalDetail = !isShowingModalDetail"
      size="xlarge"
    >
      <template slot="body" >
        <div class="flex items-start gap-20 mb-3 pt-4">
          <div class="flex w-2/5 flex-col items-center px-3">
            <div class="flex-1 flex flex-col md:flex-row pb-4">
              <div class="w-full flex-1 mx-2">
                <div class="my-2 p-1 flex">
                  <img :src="album.cover" width="200px" />
                </div>
              </div>
            </div>
            <div v-if="(isAdmin || isSuperAdmin || isOps || isReviewer) && album.status===1" class="flex flex-col md:flex-row border-b border-gray-200 pb-4">
              <div class="w-64 font-bold h-auto mt-3 text-gray-800 flex flex-row">
                <button class="text-sm  mx-2 w-full  focus:outline-none flex justify-center px-4 py-2 rounded font-bold cursor-pointer
                          bg-green-400 hover:bg-green-500
                          text-white
                             transition" @click="submitApprovalAlbum(album.id,true)">Approve
                  <!-- eslint-enable max-len -->
                </button>
                <button @click="submitApprovalAlbum(album.id,false)" class="text-sm  mx-2 w-full text-white focus:outline-none flex justify-center px-4 py-2 rounded font-bold cursor-pointer bg-red-700 hover:bg-red-800 transition mx-2">Reject
                  <!-- eslint-enable max-len -->
                </button>
              </div>
            </div>
          </div>
          <div class="flex w-full py-4">
            <div class="w-1/2">
              <form-item label='Album Name'>
                <template v-slot>
                  <p class="text-left font-bold">{{ album.name }}</p>
                </template>
              </form-item>
              <form-item v-if="!isArtist" label='Artist Name'>
                <template v-slot>
                  <p class="text-left font-bold">{{ album.artist }}</p>
                </template>
              </form-item>
              <form-item label='Year'>
                <template v-slot>
                  <p class="text-left font-bold">{{ album.year }}</p>
                </template>
              </form-item>
              <form-item label='Language'>
                <template v-slot>
                  <p class="text-left font-bold">{{ album.language }}</p>
                </template>
              </form-item>
              <form-item label='Composer'>
                <template v-slot>
                  <p class="text-left font-bold">{{ album.composer || '-' }}</p>
                </template>
              </form-item>
            </div>
            <div class="w-1/2">
              <form-item label='Subscription'>
                <template v-slot>
                  <p class="text-left font-bold">{{ album.is_subscription == 0 ? 'No' : `Yes` }}</p>
                </template>
              </form-item>
              <form-item label='Sell Song Individually'>
                <template v-slot>
                  <p class="text-left font-bold">{{ album.sell_song_individually == 0 ? 'No' : `Yes` }}</p>
                </template>
              </form-item>
              <form-item label='Paid Album'>
                <template v-slot>
                  <p class="text-left font-bold">{{ album.is_paid == 0 ? 'Free' : `Paid` }}</p>
                </template>
              </form-item>
              <form-item v-if="album.is_paid == 1" label='Album Price (USD)'>
                <template v-slot>
                  <p class="text-left font-bold">$ {{ parseFloat(toDollar(album.price)).toFixed(2) }} &nbsp;&nbsp; = {{ parseFloat(album.price).toFixed(2) }} Credits</p>
                </template>
              </form-item>
              <form-item label='Copyright'>
                <template v-slot>
                  <a :href="album.copyright" target="_blank" v-if="!!album.copyright"
                     class="underline text-left font-bold"
                  >Copyright Link</a>
                  <p class="text-left font-bold" v-else>-</p>
                </template>
              </form-item>
            </div>
          </div>
        </div>
        <div class="px-2">
          <data-tables :layout="'table'" :data="dataDetailSong" :total="dataDetailSong.length" :pagination-props="{ pageSizes: [100] }" @selection-change="handleSelectionChange">
            <el-table-column v-for="title in titleDetailSong" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
            </el-table-column>

            <el-table-column
              v-if="isAdmin || isSuperAdmin || isOps || isRecruitment"
              label="Publish" class="text-center" width="90px" >
              <template slot-scope="scope">
                <label
                  :for="'toogle'+scope.row.id"
                  class="flex items-center"
                  :class="isEligiblePublished(scope.row)? 'cursor-pointer' : 'cursor-not-allowed'"
                  style="height: 50px;"
                >
                  <!-- toggle -->
                  <div class="relative m-auto">
                    <!-- input -->
                    <input
                      :id="'toogle'+scope.row.id"
                      type="checkbox" v-model="scope.row.published"
                      @change="submitPublished(scope.row)"
                      :disabled="!isEligiblePublished(scope.row)"
                      class="hidden"
                    />
                    <!-- line -->
                    <div
                      class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                    ></div>
                    <!-- dot -->
                    <div
                      class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                    ></div>
                  </div>
                  <!-- label -->
                </label>
              </template>
            </el-table-column>

            <el-table-column label="Song" width="250px" >
              <template slot-scope="scope">
                <audio controls :src="scope.row.file" :id="'audioPlayer'+scope.row.id" class="audio-player" style="width: 240px;" controlsList="nodownload" type="audio/mp3" preload="none" >
                  Audio tag not supported
                </audio>
              </template>
            </el-table-column>

            <el-table-column label="Actions" align="right" width="150px">
              <template slot-scope="scope">
                <div class="static flex items-center justify-end text-left container-action" >
                  <VueCustomTooltip label="Add Lyrics" :position="'is-left'">
                    <button @click="addLyrics(scope.row)" class="p-2 w-8 mr-2 rounded bg-blue-600 hover:bg-blue-600 focus:outline-none" >
                      <img src="@/assets/lyrics.svg" style="height: 22px"/>
                    </button>
                  </VueCustomTooltip>
                  <VueCustomTooltip label="Set Under Review" :position="'is-left'" v-if="!isArtist">
                    <button v-if="isEligibleUnderReview(scope.row)" @click="submitUnderReview($event, scope.row)" class="p-2 w-8 mr-2 rounded bg-purple-400 hover:bg-purple-500 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'file-alt']" />
                    </button>
                  </VueCustomTooltip>
                  <VueCustomTooltip label="Approve" :position="'is-left'" v-if="!isArtist">
                    <button v-if="isEligibleApproved(scope.row)" @click="submitApproved($event, scope.row)" class="p-2 mr-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'check']" />
                    </button>
                  </VueCustomTooltip>
                  <VueCustomTooltip label="Reject" :position="'is-left'" v-if="!isArtist">
                    <button v-if="isEligibleRejected(scope.row)" @click="showingRejectModal($event, scope.row)" class="p-2 w-8 rounded bg-red-700 hover:bg-red-800 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'times']" />
                    </button>
                  </VueCustomTooltip>
                  <VueCustomTooltip v-if="(isAdmin || isSuperAdmin || isOps || isReviewer) && scope.row.statusCode==2" label="Add Tags" :position="'is-left'">
                    <button  @click="addTagsSong(scope.row)" class="p-2 w-8 rounded bg-green-400 hover:bg-green-500 focus:outline-none" >
                      <font-awesome-icon class="text-white" :icon="['fa', 'tags']" />
                    </button>
                  </VueCustomTooltip>
                </div>
              </template>
            </el-table-column>
          </data-tables>
        </div>
      </template>
    </ModalDialogDetail>
    <ModalDialog
      ref="submissionRejection"
      :isShowingModal="isShowingModalReject"
      :isLoading="isLoading"
      :error="isError"
      labelSubmit="Submit Rejection"
      title="Reject Submission"
      @toggleModal="isShowingModalReject=!isShowingModalReject"
      @save="submitRejected(songRejection)"
    >
      <template slot="body">
        <form>
          <div class="w-full" >
            <div class="flex flex-wrap -mx-3 mb-3">
              <div class="w-1/4 md:w-1/4 px-3 mb-3 md:mb-0">
                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-name-music">
                  Note
                </label>
              </div>
              <div class="w-3/4 md:w-3/4 px-5 mb-3 md:mb-0">
                <textarea class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-name-music" type="text" v-model="songRejection.note" placeholder="Note for Rejection" autocomplete="off" ></textarea>
              </div>
            </div>
          </div>
        </form>
      </template>
    </ModalDialog>
    <ModalDialog
      ref="addTags"
      :isShowingModal="isShowingModalTags"
      :isLoading="isLoading"
      :error="isError"
      labelSubmit="Save"
      title="Add Tags"
      @toggleModal="isShowingModalTags=false"
      @save="submitTags()"
    >
      <template slot="body">
        <div class="w-full py-4" >
          <form-item label='Tags'>
            <el-select
              class="w-full"
              v-model="tagsValue"
              multiple
              filterable
              remote
              allow-create
              default-first-option
              reserve-keyword
              size="large"
              placeholder="Please enter a keyword"
              :remote-method="searchTags"
              :loading="loadingTags">
              <el-option
                v-for="item in tagsOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </form-item>
        </div>
      </template>
    </ModalDialog>
    <ModalDialog
      ref="addTagsSong"
      :isShowingModal="isShowingModalTagsSong"
      :isLoading="isLoading"
      :error="isError"
      labelSubmit="Save"
      title="Add Tags Song"
      @toggleModal="isShowingModalTagsSong=false"
      @save="submitTagsSong()"
    >
      <template slot="body">
        <div class="w-full py-4" >
          <form-item label='Tags'>
            <el-select
              class="w-full"
              v-model="tagsValueSong"
              multiple
              filterable
              remote
              allow-create
              default-first-option
              reserve-keyword
              size="large"
              placeholder="Please enter a keyword"
              :remote-method="searchTagsSong"
              :loading="loadingTagsSong">
              <el-option
                v-for="item in tagsOptionSong"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </form-item>
        </div>
      </template>
    </ModalDialog>
    <ModalDialog
      ref="modalAddLyrics"
      :isShowingModal="isShowingModalLyrics"
      :isLoading="isLoading"
      :error="isError"
      labelSubmit="Upload Lyrics"
      :title="musicLyrics.lyrics ? 'Replace Lyric' : 'Add Lyric'"
      @toggleModal="isShowingModalLyrics=!isShowingModalLyrics"
      @save="uploadLyrics"
    >
      <template slot="body">
        <form class="p-8">
          <div class="w-full" >
            <form-item label='Upload Lyrics'>
              <input
                v-if="!musicLyrics.lyricsFile"
                type="file"
                class="block border border-grey-light w-full p-3 rounded"
                name="copyright_file"
                @change="onFileLyricsChanged"
                accept=".srt"
              />
              <div v-if="musicLyrics.lyricsFile" class="flex" >
                <span class="mr-2 text-gray-700 font-medium">{{musicLyrics.lyricsFile.name}}</span>
                <a @click="changeFileLyrics" ><font-awesome-icon :icon="['fas', 'times-circle']"   /></a>
              </div>
              <div class="flex flex-col pt-2">
                <text-error v-if="musicLyrics.errorSrt" text="File type must be srt." />
              </div>
            </form-item>
          </div>
        </form>
      </template>
    </ModalDialog>
  </div>
</template>
<script>
import Vue from 'vue';
import clevertap from 'clevertap-web-sdk';
import * as moment from 'moment';
import axios from 'axios';
import { validationMixin } from 'vuelidate';
import { required, numeric, decimal, maxLength } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';
import SongManagementMixins from '@/mixins/song.management.mixins';
import ModalDialog from '../components/Common/ModalDialog';
import ModalDialogDetail from '../components/Common/ModalDialogDetail';
import draggable from 'vuedraggable';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import AddAlbum from './Album/AddAlbum';
import DetailAlbum from './Album/DetailAlbum';
import EditAlbum from './Album/EditAlbum';
import helpersMixin from '../mixins/helpers.mixins';
import { Button, FormItem, TextArea, TextError } from '@/components/Layout/Form';
import Card from '@/components/Layout/Card.vue';
import { uploadLyrics } from '@/services/song';

const API_URL = process.env.API_URL;

export default {

  name: 'AlbumPage',
  mixins: [validationMixin, SongManagementMixins, helpersMixin],
  data() {
    return {
      isShowingDetailModal: false,
      isShowingModalReject: false,
      isSongHasBeenPublished: false,
      isShowingModalListSong: false,
      isShowingModalListSongEdit: false,
      isShowingModalEdit: false,
      isShowingModalTags: false,
      isShowingModalTagsSong: false,
      isEditMode: false,
      isShowingModal: false,
      isShowingModalTermsandCondition: false,
      isShowingModalDetail: false,
      isShowingModalLyrics: false,
      isFileLarge: false,
      isFileWrongFormat: false,
      filterSong: '',
      filterStatus: 0,
      isError: false,
      idAlbum: null,
      songRejection: {
        id: '',
        price: 0,
        note: '',
      },
      albumTags: {
        id: '',
        tags: '',
      },
      tagsValue: [],
      tagsOption: [],
      loadingTags: false,
      songTags: {
        id: '',
        tags: '',
      },
      tagsValueSong: [],
      tagsOptionSong: [],
      loadingTagsSong: false,
      musicLyrics: {
        music_id: null,
        lyrics: null,
        lyricsFile: null,
        errorSrt: false,
      },
      filter: {
        page: 1,
        per_page: 6,
        sortby: 'id',
        sortorder: 'desc',
        q: '',
        u: '',
      },
      album: {
        albumName: '',
        year: '',
        price: '',
        cover: null,
        musics: [],
        isPaid: false,
        copyright: null,
        is_subscription: 0,
        sell_song_individually: 0,
        language: '',
        status: 0,
      },
      fileMusic: null,
      dataAlbum: [],
      dataSong: [],
      dataDetailSong: [],
      titleSong: [
        {
          prop: 'title',
          label: 'Title',
        },
        {
          prop: 'year',
          label: 'Year',
        },
        {
          prop: 'genre',
          label: 'Category',
        },
        {
          prop: 'status',
          label: 'Status',
        },
      ],
      titleDetailSong: [
        {
          prop: 'title',
          label: 'Title',
        },
        {
          prop: 'year',
          label: 'Year',
        },
        {
          prop: 'genre',
          label: 'Category',
        },
        {
          prop: 'composer',
          label: 'Composer',
        },
        {
          prop: 'cover_type',
          label: 'Type',
        },
        {
          prop: 'original_artist_name',
          label: 'Original Artist',
        },
        {
          prop: 'status',
          label: 'Status',
        },
      ],
      filterAlbum: '',
      filterArtist: '',
      selectedRow: [],
    };
  },
  watch: {
    listSong: {
      immediate: true,
      deep: true,
      async handler(val) {
        this.dataSong = await Promise.all(val.map(async (song) => {
          let status = '';
          switch (song.status) {
            case 1:
              status = 'Under Review';
              break;
            case 2:
              status = 'Approved';
              break;
            case 3:
              status = 'Rejected';
              break;
            case 4:
              status = 'Published';
              break;
            // eslint-disable-next-line no-fallthrough
            case 0:
            default:
              status = 'Waiting for Review';
              break;
          }
          const file = await this.getMusicFile(song.file);
          return Object.assign(
            {},
            song,
            {
              status,
              statusCode: song.status,
              album: '-',
              file,
              elapsed_day: `${song.elapsed_day} ${song.elapsed_day > 1 ? 'days' : 'day'}`,
            },
          );
        }));
      },
    },
    listAlbum: {
      immediate: true,
      deep: true,
      async handler(albums) {
        this.dataAlbum = await Promise.all(albums.map(async (album) => {
          let status = '';
          switch (album.status) {
            case 1:
              status = 'Under Review';
              break;
            case 2:
              status = 'Approved';
              break;
            case 3:
              status = 'Rejected';
              break;
            case 4:
              status = 'Published';
              break;
            // eslint-disable-next-line no-fallthrough
            case 0:
            default:
              status = 'Waiting for Review';
              break;
          }
          const canDelete = album.status !== 2 || album.published !== 1;
          return Object.assign(
            {},
            album,
            {
              status,
              canDelete,
              statusCode: album.status,
            },
          );
        }));
      },
    },
    filterStatus: {
      immediate: true,
      async handler(newval, oldval) {
        if (typeof (oldval) === 'undefined') return;
        if (newval !== oldval) {
          if (newval == 0) {
            const sortby = 'id';
            const sortorder = (!this.isArtist) ? 'asc' : 'desc';
            this.filter = Object.assign(this.filter, { sortby, sortorder });
          } else {
            const sortby = 'status_updated_at';
            const sortorder = 'desc';
            this.filter = Object.assign(this.filter, { sortby, sortorder });
          }
          this.filter = Object.assign(this.filter, { status: newval });
          // await this.requestListSong(Object.assign(this.filter, { status: newval }));
          await this.searchAlbum();
        }
      },
    },
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    const sortby = 'id';
    const sortorder = (!this.isArtist) ? 'asc' : 'desc';
    this.filter = Object.assign(this.filter, { sortby, sortorder });
    await this.requestListGenreSong();
    await this.searchAlbum();
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isArtist', 'isFinance', 'isOps', 'isReviewer', 'isRecruitment', 'getUser']),
    ...mapGetters('SongModule', ['listGenreSong']),
    ...mapGetters('NotificationModule', ['isLoading', 'getStatus']),
    ...mapGetters('AlbumModule', [
      'listAlbum',
      'totalAlbum',
      'listSong',
      'totalSong',
      'countWaitingForReviewAlbum',
      'countUnderReviewAlbum',
      'countApprovedAlbum',
      'countRejectedAlbum',
      'countPublishedAlbum',
    ]),
    optionTable() {
      return this.isAdmin ? 'Change Status' : 'Options';
    },
    titles() {
      if (this.isArtist) {
        return [{
          prop: 'name',
          label: 'Album Name',
        }, {
          prop: 'year',
          label: 'Album Release Year',
        }, {
          prop: 'status',
          label: 'Status',
        }];
      }
      return [{
        prop: 'name',
        label: 'Album Name',
      }, {
        prop: 'artist',
        label: 'Artist Name',
      }, {
        prop: 'year',
        label: 'Album Release Year',
      }, {
        prop: 'status',
        label: 'Status',
      }];
    },
  },
  methods: {
    ...mapActions('AlbumModule', [
      'requestListAlbum',
      'requestListSongForAlbum',
      'requestDetailAlbum',
      'requestPublishAlbum',
      'requestUnpublishAlbum',
      'requestDeleteAlbum',
      'requestApprovalAlbum',
      'requestGetTagsAlbum',
      'requestSaveTagsAlbum',
      'requestSubmitSubmissionProcessAlbum',
    ]),
    ...mapActions('SongModule', [
      'requestListSong',
      'requestAddSubmissionFreeSong',
      'requestListGenreSong',
      'requestDetailSubmission',
      'requestSubmitSubmissionProcess',
      'requestSubmitSubmissionPublish',
      'requestSubmitSubmissionUnpublish',
      'requestGetTags',
      'requestSaveTags',
      'requestUploadLyrics',
    ]),
    ...mapActions('AuthModule', [
      'requestDetailUser',
    ]),
    toggleAction(event) {
      let popupaction = event.srcElement.closest('.container-action').children[1];
      if (popupaction == null) {
        popupaction = event.srcElement.closest('.container-action').children[0];
      }
      popupaction.classList.toggle('hidden');
    },
    async submitPublished(row) {
      try {
        const submissionData = {
          id: row.content_id,
        };
        if (row.published) {
          await this.requestSubmitSubmissionPublish({ submissionData, filter: this.filter });
          this.isPublishedSong = true;
        } else {
          await this.requestSubmitSubmissionUnpublish({ submissionData, filter: this.filter });
          this.isPublishedSong = false;
        }
        this.isSongHasBeenPublished = true;
        setTimeout(this.toggleToast, 2000);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    async submitUnderReview(event, row) {
      this.toggleAction(event);
      try {
        const submissionData = {
          id: row.content_id,
          status: 1,
        };
        await this.requestSubmitSubmissionProcess({ submissionData, filter: this.filter });
        this.getDetailAlbum(this.album);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    async submitUnderReviewAlbum(event, row) {
      this.toggleAction(event);
      try {
        const submissionData = {
          id: row.id,
          status: 1,
        };
        await this.requestSubmitSubmissionProcessAlbum({ submissionData, filter: this.filter });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    showingRejectModal(event, song) {
      this.isShowingModalReject = true;
      this.toggleAction(event);
      this.songRejection = song;
    },
    async submitRejected(row) {
      try {
        const submissionData = {
          id: row.content_id,
          status: 3,
          note: row.note,
        };
        await this.requestSubmitSubmissionProcess({ submissionData, filter: this.filter });
        this.isShowingModalReject = false;
        this.getDetailAlbum(this.album);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    async submitApproved(event, row) {
      this.toggleAction(event);
      try {
        const submissionData = {
          id: row.content_id,
          status: 2,
        };
        await this.requestSubmitSubmissionProcess({ submissionData, filter: this.filter });
        await this.getDetailAlbum(this.album);
        this.requestListAlbum(this.filter);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    toggleModal() {
      this.isShowingModal = !this.isShowingModal;
    },
    toggleModalEdit() {
      this.isShowingModalEdit = !this.isShowingModalEdit;
    },
    async edit(event, album) {
      this.toggleAction(event);
      this.idAlbum = album.id;
      this.toggleModalEdit();
    },
    async deleteAlbum(event, album) {
      this.toggleAction(event);
      Vue.swal({
        title: 'Delete Data!',
        text: `Are you sure to delete album: ${album.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestDeleteAlbum({ album: { id: album.id }, filter: this.filter });
          this.$swal('Deleted', `You successfully delete album: ${album.name}`, 'success');
          this.idAlbum = '';
        } else {
          this.idAlbum = '';
        }
      });
    },
    changeFileMusic(index) {
      this.input.contents[index].fileMusic = null;
    },

    onFileMusicChange(e, index) {
      const file = e.target.files[0];
      this.input.contents[index].fileMusic = URL.createObjectURL(file);
    },
    async submitForReview() {
      await this.$refs.addAlbumContent.submit();
    },
    async onSubmitAlbum(state) {
      this.isShowingModal = false;
      await this.searchAlbum();
    },
    async onSubmitEditAlbum(state) {
      this.isShowingModalEdit = false;
      await this.searchAlbum();
    },
    async submitForUpdate() {
      await this.$refs.editAlbumContent.submit();
    },
    async showingListSongEdit(e) {
      e.preventDefault();
      this.isShowingModalListSongEdit = !this.isShowingModalListSongEdit;
      this.dataSong = [];
      await this.requestListSongForAlbum(this.filterSong);
    },
    async getMusicFile(file) {
      const hostname = file.indexOf('//') > -1 ? `https://${file.split('/')[2]}` : file.split('/')[0];
      const fileAudio = await axios({
        method: 'get',
        url: file.replace(hostname, API_URL),
      });
      return fileAudio.data;
    },
    handleSelectionChange(val) {
      this.selectedRow = val;
    },
    addToAlbum() {
      this.isShowingModalListSong = !this.isShowingModalListSong;
      this.input.contents = [...this.input.contents, ...this.selectedRow];
    },
    addToAlbumEdit() {
      this.isShowingModalListSongEdit = !this.isShowingModalListSongEdit;
      this.update.contents = [...this.update.contents, ...this.selectedRow];
    },
    isEligibleUnderReview(row) {
      return (!this.isArtist && !this.isFinance && !this.isRecruitment) && row.statusCode === 0;
    },
    isEligibleRejected(row) {
      return (!this.isArtist && !this.isFinance && !this.isRecruitment) && row.statusCode === 1;
    },
    isEligibleApproved(row) {
      return (!this.isArtist && !this.isFinance && !this.isRecruitment) && row.statusCode === 1;
    },
    isEligiblePublished(row) {
      return (!this.isArtist && !this.isFinance && !this.isReviewer) && row.statusCode === 2;
    },
    isRejected(status) {
      return status === 3;
    },
    isApproved(status) {
      return status === 2;
    },
    async detail(event, album) {
      // this.toggleAction(event);
      try {
        this.idAlbum = album.id;
        await this.getDetailAlbum(album);
        // this.album.isFree =  !album.is_paid && !album.is_subscription?true:false;
        this.album.isPaid = !!parseInt(album.is_paid);
        // this.album.isSubscription = parseInt(album.is_subscription)?true:false;
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
      // this.album = album;
      this.isShowingModalDetail = !this.isShowingModalDetail;
    },
    async getDetailAlbum(albumRef) {
      const dataLanguages = this.getLanguages();
      const dataAlbum = await this.requestDetailAlbum(this.idAlbum);
      this.album = Object.assign({}, dataAlbum, { price: albumRef.price, artist: albumRef.artist });
      const findLang = dataLanguages.find(lang => lang.value == this.album.language);
      this.album.language = findLang != undefined ? findLang.label : '-';
      this.dataDetailSong = await Promise.all(this.album.content.map(async (song) => {
        let status = '';
        switch (song.status) {
          case 1:
            status = 'Under Review';
            break;
          case 2:
            status = 'Approved';
            break;
          case 3:
            status = 'Rejected';
            break;
          case 4:
            status = 'Published';
            break;
            // eslint-disable-next-line no-fallthrough
          case 0:
          default:
            status = 'Waiting for Review';
            break;
        }
        let genres = '';
        if (song.genres.length > 0) {
          genres = this.album.content[0].genres.map(c => {
            return c.name
          }).join(', ');
        } else {
          genres = song.genre;
        }
        const file = await this.getMusicFile(song.file);
        return Object.assign(
          {},
          song,
          {
            genre: genres,
            cover_type: song.is_cover === 1 ? 'Cover' : 'Original',
            status,
            statusCode: song.status,
            file,
            elapsed_day: `${song.elapsed_day} ${song.elapsed_day > 1 ? 'days' : 'day'}`,
          },
        );
      }));
    },
    async searchAlbum() {
      // eslint-disable-next-line max-len
      await this.requestListAlbum(Object.assign(this.filter, { q: this.filterAlbum, u: this.filterArtist, status: this.filterStatus }));
    },
    resetAlbum() {
      this.$refs.tableAlbum.$refs.elTable.clearSort();
      this.filterAlbum = '';
      this.filterArtist = '';
      this.searchAlbum();
    },
    onChangeAlbumTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'desc' : 'asc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      if (!this.isArtist) {
        if (this.filterStatus == 0) {
          sortby = 'id';
          sortorder = 'asc';
        } else {
          sortby = 'status_updated_at';
          sortorder = 'desc';
        }
        // sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      }
      this.filter = Object.assign(this.filter, { sortorder, sortby, page });
      this.searchAlbum();
    },
    async submitPublishedAlbum(row) {
      try {
        if (row.published) {
          await this.requestPublishAlbum({ album: { id: row.id }, filter: this.filter });
          this.isPublishedSong = true;
        } else {
          await this.requestUnpublishAlbum({ album: { id: row.id }, filter: this.filter });
          this.isPublishedSong = false;
        }
        this.isSongHasBeenPublished = true;
        setTimeout(this.toggleToast, 2000);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    async submitApprovalAlbum(albumId, approveStatus) {
      try {
        await this.requestApprovalAlbum({ album: { approved: approveStatus, id: this.idAlbum }, filter: this.filter });
        await this.getDetailAlbum(this.album);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    addTags(row) {
      this.albumTags = row;
      if (this.albumTags.tags) {
        this.tagsValue = this.albumTags.tags.split(',');
      } else {
        this.tagsValue = [];
      }

      this.isShowingModalTags = true;
    },
    async searchTags(query) {
      if (query !== '') {
        this.loadingTags = true;
        const tags = await this.requestGetTagsAlbum({ q: query });
        this.loadingTags = false;
        this.tagsOption = tags.map(item => ({ value: item.name, label: item.name }));
      } else {
        this.tagsOption = [];
      }
    },
    async submitTags() {
      let tags = '';
      this.tagsValue.forEach((t) => {
        if (t !== '') {
          tags += `${t},`;
        }
      });
      if (tags !== '') {
        tags = tags.substr(0, tags.length - 1);
      }
      await this.requestSaveTagsAlbum({
        data: {
          album_id: this.albumTags.id,
          tag: tags,
        },
        filter: this.filter });
      this.isShowingModalTags = false;
    },
    addTagsSong(row) {
      this.songTags = row;
      if (this.songTags.tags) {
        this.tagsValueSong = this.songTags.tags.split(',');
      } else {
        this.tagsValueSong = [];
      }

      this.isShowingModalTagsSong = true;
    },
    async searchTagsSong(query) {
      if (query !== '') {
        this.loadingTagsSong = true;
        const tags = await this.requestGetTags({ q: query });
        this.loadingTagsSong = false;
        this.tagsOptionSong = tags.map(item => ({ value: item.name, label: item.name }));
      } else {
        this.tagsOptionSong = [];
      }
    },
    async submitTagsSong() {
      let tags = '';
      this.tagsValueSong.forEach((t) => {
        if (t !== '') {
          tags += `${t},`;
        }
      });
      if (tags !== '') {
        tags = tags.substr(0, tags.length - 1);
      }
      await this.requestSaveTags({
        data: {
          music_id: this.songTags.id,
          tag: tags,
        },
        filter: this.filter });
      await this.getDetailAlbum(this.album);
      this.isShowingModalTagsSong = false;
    },
    onFileLyricsChanged(e) {
      const file = e.target.files[0];
      const fileSplit = file.name.split('.');
      const ext = fileSplit[fileSplit.length - 1];
      if(ext !== 'srt'){
        this.musicLyrics.errorSrt = true;
      }else{
        this.musicLyrics.lyricsFile = file
        this.musicLyrics.errorSrt = false
      }

      console.log(file)
    },
    changeFileLyrics(e) {
      this.musicLyrics.lyricsFile = null;
    },
    addLyrics(row){
      this.musicLyrics = {
        music_id: row.id,
        lyrics: row.lyric,
        lyricsFile: null,
        errorSrt: false,
      }
      this.isShowingModalLyrics = true;
    },
    async uploadLyrics() {
      if(!!this.musicLyrics.lyricsFile && !this.musicLyrics.errorSrt){
        const data = new FormData();
        data.append('music_id',this.musicLyrics.music_id.toString())
        data.append('file',this.musicLyrics.lyricsFile)
        await this.requestUploadLyrics(data);
        this.musicLyrics = {
          music_id: null,
          lyrics: null,
          lyricsFile: null,
          errorSrt: false,
        }
        this.isShowingModalLyrics = false;
        await this.getDetailAlbum(this.album);
      }
    }
  },
  components: {
    TextError,
    ModalDialog,
    ModalDialogDetail,
    draggable,
    VueCustomTooltip,
    AddAlbum,
    EditAlbum,
    Button,
    Card,
    FormItem,
    TextArea
  },
};
</script>
<style scoped>
.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #48bb78;
}
.max-400{
  max-height: 400px;
}
.cursor-move{
  cursor:move
}
.music-drag {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>



// WEBPACK FOOTER //
// src/views/Album.vue